<template>
  <v-planning-tool
    :company="company"
    @refreshListings="getBookedLoads()"/>
</template>

<script>
import loadsRoutingMixin from '@/mixins/loadsRoutingMixin';
import VPlanningTool from './components/PlanningTool';

export default {
  name: 'PlanningSection',
  mixins: [
    loadsRoutingMixin,
  ],
  components: {
    VPlanningTool,
  },
  props: {
    company: {
      type: Object,
    },
  },
  methods: {
    getBookedLoads() {
      this.$store.dispatch('bookedLoads/getBookedLoads', this.company.id);
    },
  },
  beforeRouteLeave(to, from, next) {
    // Before leave save id in local storage
    const sectionKey = `${from.name}_loadGroupId`;
    if (this.loadGroupId) {
      localStorage.setItem(sectionKey, this.loadGroupId);
    } else {
      localStorage.removeItem(sectionKey);
    }
    next();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Loads/PlanningSection.vue